import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var CropRotate = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M35.177 13.719h-4.402V9.318c0-.5-.4-.9-.9-.9s-.9.4-.9.9v4.4H14.969c-.9 0-1.6.7-1.6 1.6v14.003H8.966c-.5 0-.9.4-.9.9s.4.9.9.9h4.401v4.401c0 .5.4.9.9.9s.901-.4.901-.9v-4.4h14.006c.9 0 1.6-.7 1.6-1.601V15.519h4.402c.5 0 .9-.4.9-.9s-.4-.9-.9-.9ZM28.875 29.32H15.069V15.519h13.706V29.32h.1ZM18.57 3.617c0 .2 0 .4-.1.6l-2.4 4.5c-.2.5-.8.6-1.301.4-.5-.2-.6-.8-.4-1.3l1.4-2.7c-.1 0-.2 0-.3.1C7.066 7.717 2.264 16.72 4.865 25.22c.2.5-.1 1-.6 1.2-.5.1-1-.1-1.2-.6C.162 16.32 5.564 6.317 14.968 3.417l-2.3-1.2c-.501-.2-.601-.8-.401-1.3.2-.5.8-.6 1.3-.4l4.502 2.4c.3.2.5.4.5.7ZM28.975 41.423l2.3 1.2c.5.2.6.8.4 1.3-.2.5-.8.6-1.3.4l-4.502-2.4c-.4-.2-.6-.8-.4-1.3l2.401-4.5c.2-.501.8-.601 1.3-.401.5.2.601.8.4 1.3l-1.4 2.7c.1 0 .2 0 .2-.1 8.504-2.5 13.306-11.501 10.805-20.003-.2-.5.1-1 .6-1.2.5-.1 1 .1 1.2.6 2.802 9.502-2.6 19.503-12.004 22.404Z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});
CropRotate.displayName = 'CropRotate';
CropRotate.defaultProps = {
  'aria-label': 'CropRotate'
};
export default CropRotate;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/CropRotate.js
// module id = 3766
// module chunks = 11